import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../utils/cn"

const dataListVariants = cva(
    "w-full",
    {
        variants: {
            variant: {
                default: "grid grid-cols-1 gap-2 text-sm",
                box: "grid grid-cols-1 md:grid-cols-3 gap-2 p-[10px] border border-ink shadow-brutal-md bg-gold/90 m-[30px] max-w-[900px] min-w-[94%] justify-start",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
)

export interface DataListProps
    extends React.HTMLAttributes<HTMLDListElement>,
    VariantProps<typeof dataListVariants> { }

export const DataList = React.forwardRef<HTMLDListElement, DataListProps>(
    ({ className, variant, ...props }, ref) => (
        <dl
            ref={ref}
            className={cn(dataListVariants({ variant, className }))}
            {...props}
        />
    )
)
DataList.displayName = "DataList"

const dataItemVariants = cva(
    "",
    {
        variants: {
            variant: {
                default: "flex flex-row items-center justify-between border-b border-dashed border-gray-600 pb-1 last:border-0",
                box: "p-[5px] m-[5px] border border-ink shadow-inset-soft break-all min-w-0",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
)

export interface DataItemProps
    extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof dataItemVariants> { }

export const DataItem = React.forwardRef<HTMLDivElement, DataItemProps>(
    ({ className, variant, ...props }, ref) => (
        <div
            ref={ref}
            className={cn(dataItemVariants({ variant, className }))}
            {...props}
        />
    )
)
DataItem.displayName = "DataItem"

export const DataLabel = React.forwardRef<
    HTMLElement,
    React.HTMLAttributes<HTMLElement>
>(({ className, ...props }, ref) => (
    <dt
        ref={ref}
        className={cn("font-bold text-gray-800 inline mr-1", className)}
        {...props}
    />
))
DataLabel.displayName = "DataLabel"

export const DataValue = React.forwardRef<
    HTMLElement,
    React.HTMLAttributes<HTMLElement>
>(({ className, ...props }, ref) => (
    <dd
        ref={ref}
        className={cn("font-medium text-gray-900 inline", className)}
        {...props}
    />
))
DataValue.displayName = "DataValue"










